import React, { useState } from "react";
import "./ResultList.css";
import MovieDetailSearch from "./MovieDetailSearch";
export default function ResultList({ results }) {
  const [selectedMovieSearch, setSelecedMovieSearch] = useState(null);
  const handleMovieClickSearch = (result) => {
    setSelecedMovieSearch((prev) =>
      prev && prev.id === result.id ? null : result
    );
    //cuộn trang
    if (selectedMovieSearch) {
      window.scrollTo({
        top: document.body.scrollHeight,
        behavior: "smooth",
      });
    }
    console.log(result);
  };
  return (
    <div className="contain-result">
      <h2>Seach Result</h2>
      <div className="result-movies">
        {results.length > 0 ? (
          results.map((result) => (
            <div key={result.id} className="result-item">
              <img
                src={`https://image.tmdb.org/t/p/original${result.poster_path}`}
                alt={result.title}
                className="result-poster"
                onClick={() => handleMovieClickSearch(result)}
              />
            </div>
          ))
        ) : (
          <p>No results found.</p>
        )}
      </div>
      {selectedMovieSearch && (
        <MovieDetailSearch movieDataSearch={selectedMovieSearch} />
      )}
    </div>
  );
}
